/**
 * Tiny "CN" badge that flags a Xero credit-note. Same visual treatment
 * the sales-compare invoice cell uses (yellow background, dark gold
 * border, bold CN text) - extracted so the filter panel and the table
 * cell render identical chrome.
 */
import React from 'react'
import { Box } from '@mui/material'

interface CreditNoteBadgeProps {
  /** Tooltip text shown on hover. Defaults to "Credit note". */
  title?: string
  /** Slightly larger variant for non-cell contexts (e.g. inside a filter
   *  toggle label) where 0.65rem reads too small alongside body2 text. */
  size?: 'sm' | 'md'
}

const CreditNoteBadge: React.FC<CreditNoteBadgeProps> = ({
  title = 'Credit note',
  size = 'sm',
}) => (
  <Box
    component="span"
    title={title}
    sx={{
      fontSize: size === 'sm' ? '0.65rem' : '0.7rem',
      fontWeight: 700,
      px: 0.5,
      py: '1px',
      borderRadius: 0.5,
      backgroundColor: '#FFF4CE',
      color: '#6A4E00',
      border: '1px solid #E6C200',
      lineHeight: 1.2,
      display: 'inline-block',
    }}
  >
    CN
  </Box>
)

export default CreditNoteBadge
